import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Constants, getBackendUrl } from '../../util/Constants';
import {
  getGlossaryLanguage,
  isBigScreen,
  isHD,
  isMobile,
  isTablet,
  removeClass,
} from '../../util/DataUtil';
import { formatCommaSeparator } from '../../util/RegexUtil';
import { getMetricSystemForLanguage } from '../../util/LocationsUtil';

const FacilityTable = (props) => {
  const [glossariesData, setGlossariesData] = useState([]);
  const screenSize = useSelector((state) => state.pageSlice.screenSize);
  const host = getBackendUrl(useSelector((state) => state.host.host));
  const metricSystem = getMetricSystemForLanguage(props.lang);

  useEffect(() => {
    fetchGlossaries();
    // doAligning();
  }, []);

  // useEffect(() => {
  //     const fetchGlossaries = async () => {
  //         if (props?.lang && props?.lang !== 'en') {
  //             try {
  //                 const response = await fetch(`${host.baseApiUrlRemote}glossaries/v1/${getGlossaryLanguage(props?.lang)}`);
  //                 const gloss = await response.json();
  //                 setGlossariesData(gloss);
  //             } catch (error) {
  //                 setGlossariesData([]);
  //             }
  //         } else {
  //             setGlossariesData([]);
  //         }
  //     };

  //     fetchGlossaries();
  // }, [props?.lang]);

  useEffect(() => {
    doAligning();

    return () => {
      removeClass('wrap-text');
      removeClass('no-margin-left');
    };
  }, [glossariesData, screenSize]);

  const doAligning = () => {
    let tables = document.getElementsByClassName('table');
    let counter = 0;
    let tableDescriptionHeightValues = [];
    let specificationOfTable0 = [];
    let specificationOfTable1 = [];
    let specificationOfTable2 = [];

    for (let table = 0; table < tables.length; table++) {
      counter++;

      let newList = tables[table].childNodes;
      tableDescriptionHeightValues.push(
        tables[table].childNodes[1].offsetHeight
      );

      newList.forEach((child) => {
        if (child.childNodes[0]?.innerHTML) {
          if (table == 0) {
            specificationOfTable0.push(child.childNodes[0].offsetWidth);
          }
          if (table == 1) {
            specificationOfTable1.push(child.childNodes[0].offsetWidth);
          }
          if (table == 2) {
            specificationOfTable2.push(child.childNodes[0].offsetWidth);
          }
        }
        if (child.className == 'table-specification') {
          let child1 = child.childNodes[0].offsetWidth;
          let child2 = child.childNodes[1].offsetWidth;

          if (table == 0) {
            if (
              child.childNodes[1].getBoundingClientRect().x < 65 ||
              child.childNodes[1].getBoundingClientRect().width + 24 > 170
            ) {
              tables[table].classList.add('wrap-text');
              child.childNodes[1].classList.add('no-margin-left');
            }
          } else if (table == 2) {
            if (
              child.childNodes[1].getBoundingClientRect().x <= 816 &&
              !isMobile(screenSize) &&
              !isTablet(screenSize)
            ) {
              tables[table].classList.add('wrap-text');
              child.childNodes[1].classList.add('no-margin-left');
            }
            if (
              child.childNodes[1].getBoundingClientRect().top <= 286.5 &&
              (isMobile(screenSize) || isTablet(screenSize))
            ) {
              tables[table].classList.add('wrap-text');
              child.childNodes[1].classList.add('no-margin-left');
            }
          } else if (table == 1) {
            if (
              child.childNodes[1].getBoundingClientRect().x <= 500 &&
              !isMobile(screenSize) &&
              !isTablet(screenSize)
            ) {
              tables[table].classList.add('wrap-text');
              child.childNodes[1].classList.add('no-margin-left');
            }
          }
          if (table == counter - 1) {
            if (child1 + child2 + 24 >= 360 && isBigScreen(screenSize)) {
              tables[table].classList.add('wrap-text');
            } else if (child1 + child2 + 24 >= 316 && isMobile(screenSize)) {
              tables[table].classList.add('wrap-text');
            } else if (child1 + child2 + 24 >= 480 && isHD(screenSize)) {
              tables[table].classList.add('wrap-text');
            } else if (child1 + child2 + 24 >= 440 && isTablet(screenSize)) {
              tables[table].classList.add('wrap-text');
            }
          }
        }
      });
    }

    let maxHeightOfDescription = Math.max(...tableDescriptionHeightValues);

    for (let table = 0; table < tables.length; table++) {
      tables[table].childNodes[1].style.minHeight =
        `${maxHeightOfDescription}px`;

      let newList = tables[table].childNodes;

      newList.forEach((child) => {
        if (child.childNodes[0]?.innerHTML) {
          if (table == 0) {
            child.childNodes[0].style.minWidth = `${Math.max(...specificationOfTable0)}px`;
          }
          if (table == 1) {
            child.childNodes[0].style.minWidth = `${Math.max(...specificationOfTable1)}px`;
          }
          if (table == 2) {
            child.childNodes[0].style.minWidth = `${Math.max(...specificationOfTable2)}px`;
          }
        }
      });
    }
  };

  const getSpecificationName = (value) => {
    let specification;

    switch (value) {
      case 'field_building_structure':
        specification = 'Building structure';
        break;
      case 'field_total_building_size':
        specification = 'Total building size';
        break;
      case 'field_utility_power_capacity':
        specification = 'Utility power capacity';
        break;
      case 'field_ups_redundancy':
        specification = 'UPS redundancy';
        break;
      case 'field_generator_capacity':
        specification = 'Generator capacity';
        break;
      case 'max_power_density':
        specification = 'Max. power density';
        break;
      case 'field_cooling_plant_redundancy':
        specification = 'Cooling redundancy';
        break;
      case 'field_design_pue':
        specification = 'Design pue';
        break;
      case 'field_carbon_free_energy':
        specification = 'Carbon-free energy';
        break;
      case 'field_renewable_energy':
        specification = 'Renewable energy';
        break;
      case 'field_ups_power_capacity':
        specification = 'UPS power capacity';
        break;
    }
    return specification;
  };

  // const matchTranslation = (value, glossaries, lang) => {
  //     if(!value || !lang){
  //         return;
  //     }

  //     if(!glossaries.length && lang == 'en'){
  //         return value;
  //     }

  //     for(let glossary of glossaries){
  //         if(value.toLowerCase() === glossary['en'].toLowerCase()){
  //             return glossary[getGlossaryLanguage(lang)]
  //         }
  //     }
  // }

  const matchTranslation = (value, glossaries, lang) => {
    if (!value || !lang) {
      return;
    }

    if (!glossaries.length && lang === 'en') {
      return value;
    }

    const lowerValue = value.toLowerCase();
    const glossaryLang = getGlossaryLanguage(lang);

    const glossaryMap = new Map(
      glossaries.map((glossary) => [
        glossary['en'].toLowerCase(),
        glossary[glossaryLang],
      ])
    );

    return glossaryMap.get(lowerValue) || value;
  };

  const fetchGlossaries = () => {
    if (props?.lang && props?.lang !== 'en') {
      fetch(
        host.baseApiUrlRemote +
          'glossaries/v1/' +
          getGlossaryLanguage(props?.lang)
      )
        .then((response) => response.json())
        .then((gloss) => {
          setGlossariesData(gloss);
        });
    } else {
      setGlossariesData([]);
    }
  };

  const renderFacilityTables = (items) => {
    if (!items || items.length === 0) {
      return;
    }
    let counter = 1;

    return items.map((item, index) => {
      counter++;
      //this one removes field_utility_power_capacity only from frontend
      const updatedSpecifications = item.field_facility_specifications.filter(
        (spec) => spec.value !== 'field_utility_power_capacity'
      );

      return (
        <div className={'table'} key={`table-${item?.field_paragraph_title?.[0]?.value || index}`}>
          <h2 className="table-title">
            {item?.field_paragraph_title[0]?.value}
          </h2>
          <p className="table-description">
            {item?.field_paragraph_subtitle[0]?.value}
          </p>

          {updatedSpecifications.map((option, i) => {
            const specification = {
              value: option.value,
              name: getSpecificationName(option.value),
            };
            const totalBuildingSizeFt =
              props?.facilityData.field_total_building_size_in_ft2?.[0]?.value;
            const totalBuildingSizeM =
              props?.facilityData.field_total_building_size_in_m2?.[0]?.value;
            return (
              props?.facilityData[specification?.value] && (
                <div
                  className="table-specification"
                  key={`facility-specification-${specification?.value || i}`}
                >
                  {props?.facilityData[specification?.value] && (
                    <label className="specification-name">
                      {matchTranslation(
                        specification?.name,
                        glossariesData,
                        props?.lang
                      )}
                      :
                    </label>
                  )}
                  {specification?.value === 'field_total_building_size' &&
                  props?.facilityData[specification?.value] ? (
                    metricSystem === 'Imperial' ? (
                      <span className="specification-value">{`${formatCommaSeparator(totalBuildingSizeFt)} ft² (${formatCommaSeparator(totalBuildingSizeM)} m²)`}</span>
                    ) : (
                      <span className="specification-value">{`${formatCommaSeparator(totalBuildingSizeM)} m² (${formatCommaSeparator(totalBuildingSizeFt)} ft²)`}</span>
                    )
                  ) : (
                    props?.facilityData[specification?.value] && (
                      <span className="specification-value">
                        {formatCommaSeparator(
                          props?.facilityData[specification?.value]
                        )}
                      </span>
                    )
                  )}
                </div>
              )
            );
          })}
        </div>
      );
    });
  };

  return (
    <div className="inner-container" key={'facility-table'}>
      <div className="facility-table">
        <span className="table-heading">
          {props?.children?.field_title_field[0]?.value}
        </span>
        <div className="tables">
          {renderFacilityTables(
            props?.children.field_facility_specifications_li
              ?.facility_specifications
          )}
        </div>
      </div>
    </div>
  );
};

export default FacilityTable;
